import {
    BRAND__FETCH_SITE__START,
    BRAND__FETCH_SITE__SUCCESS,
    BRAND__FETCH_SITE__FAILURE,
    BRAND__FETCH_FRAME__START,
    BRAND__FETCH_FRAME__SUCCESS,
    BRAND__FETCH_FRAME__FAILURE,
    BRAND__FETCH_STATUS__START,
    BRAND__FETCH_STATUS__SUCCESS,
    BRAND__FETCH_STATUS__FAILURE,
    BRAND__FETCH_DC__START,
    BRAND__FETCH_DC__SUCCESS,
    BRAND__FETCH_DC__FAILURE,
    BRAND__SMS_SEND__START,
    BRAND__SMS_SEND__SUCCESS,
    BRAND__SMS_SEND__FAILURE,
    BRAND__SMS_CHECK__START,
    BRAND__SMS_CHECK__SUCCESS,
    BRAND__SMS_CHECK__FAILURE,
    BRAND__ERROR_CHECK__START,
    BRAND__ERROR_CHECK__SUCCESS,
    BRAND__ERROR_CHECK__FAILURE,
} from './actions';

const initialState = {
    site: {
        data: {},
        isLoading: false,
        isLoaded: false,
        error: null,
    },
    frame: {
        data: {},
        isLoading: false,
        isLoaded: false,
        error: null,
    },
    status: {
        data: {},
        isLoading: false,
        isLoaded: false,
        error: null,
    },
    dealerCenter: {
        data: {},
        isLoading: false,
        isLoaded: false,
        error: null,
    },
    dealerCenterDetailed: {
        data: {},
        isLoading: false,
        isLoaded: false,
        error: null,
    },
    smsSendStatus: {
        data: {},
        isLoading: false,
        isLoaded: false,
        error: null,
    },
    smsCheckStatus: {
        data: {},
        isLoading: false,
        isLoaded: false,
        error: null,
    },
    errorCheckStatus: {
        data: {},
        isLoading: false,
        isLoaded: false,
        error: null,
    },
};
export default function BRANDReducer(state = initialState, action = {}) {
    switch (action.type) {
        case BRAND__FETCH_SITE__START: {
            return {
                ...state,
                site: {
                    data: {},
                    isLoading: true,
                    isLoaded: false,
                    error: null,
                },
            };
        }
        case BRAND__FETCH_SITE__SUCCESS: {
            return {
                ...state,
                site: {
                    data: action.data,
                    isLoading: false,
                    isLoaded: true,
                    error: null,
                },
            };
        }
        case BRAND__FETCH_SITE__FAILURE: {
            return {
                ...state,
                site: {
                    data: {},
                    isLoading: false,
                    isLoaded: false,
                    error: action.error,
                },
            };
        }
        case BRAND__FETCH_FRAME__START: {
            return {
                ...state,
                frame: {
                    data: {},
                    isLoading: true,
                    isLoaded: false,
                    error: null,
                },
            };
        }
        case BRAND__FETCH_FRAME__SUCCESS: {
            return {
                ...state,
                frame: {
                    data: action.data,
                    isLoading: false,
                    isLoaded: true,
                    error: null,
                },
            };
        }
        case BRAND__FETCH_FRAME__FAILURE: {
            return {
                ...state,
                frame: {
                    data: {},
                    isLoading: false,
                    isLoaded: false,
                    error: action.error,
                },
            };
        }

        case BRAND__FETCH_STATUS__START: {
            return {
                ...state,
                status: {
                    data: {},
                    isLoading: true,
                    isLoaded: false,
                    error: null,
                },
            };
        }
        case BRAND__FETCH_STATUS__SUCCESS: {
            return {
                ...state,
                status: {
                    data: action.data,
                    isLoading: false,
                    isLoaded: true,
                    error: null,
                },
            };
        }
        case BRAND__FETCH_STATUS__FAILURE: {
            return {
                ...state,
                status: {
                    data: {},
                    isLoading: false,
                    isLoaded: false,
                    error: action.error,
                },
            };
        }

        case BRAND__FETCH_DC__START: {
            return {
                ...state,
                dealerCenter: {
                    data: {},
                    isLoading: true,
                    isLoaded: false,
                    error: null,
                },
            };
        }
        case BRAND__FETCH_DC__SUCCESS: {
            return {
                ...state,
                dealerCenter: {
                    data: action.data,
                    isLoading: false,
                    isLoaded: true,
                    error: null,
                },
            };
        }
        case BRAND__FETCH_DC__FAILURE: {
            return {
                ...state,
                dealerCenter: {
                    data: {},
                    isLoading: false,
                    isLoaded: false,
                    error: action.error,
                },
            };
        }

        case BRAND__SMS_SEND__START: {
            return {
                ...state,
                smsSendStatus: {
                    data: {},
                    isLoading: true,
                    isLoaded: false,
                    error: null,
                },
            };
        }
        case BRAND__SMS_SEND__SUCCESS: {
            return {
                ...state,
                smsSendStatus: {
                    data: action.data,
                    isLoading: false,
                    isLoaded: true,
                    error: null,
                },
            };
        }
        case BRAND__SMS_SEND__FAILURE: {
            return {
                ...state,
                smsSendStatus: {
                    data: {},
                    isLoading: false,
                    isLoaded: false,
                    error: action.error,
                },
            };
        }

        case BRAND__SMS_CHECK__START: {
            return {
                ...state,
                smsCheckStatus: {
                    data: {},
                    isLoading: true,
                    isLoaded: false,
                    error: null,
                },
            };
        }
        case BRAND__SMS_CHECK__SUCCESS: {
            return {
                ...state,
                smsCheckStatus: {
                    data: action.data,
                    isLoading: false,
                    isLoaded: true,
                    error: null,
                },
            };
        }
        case BRAND__SMS_CHECK__FAILURE: {
            return {
                ...state,
                smsCheckStatus: {
                    data: {},
                    isLoading: false,
                    isLoaded: false,
                    error: action.error,
                },
            };
        }

        case BRAND__ERROR_CHECK__START: {
            return {
                ...state,
                errorCheckStatus: {
                    data: {},
                    isLoading: true,
                    isLoaded: false,
                    error: null,
                },
            };
        }
        case BRAND__ERROR_CHECK__SUCCESS: {
            return {
                ...state,
                errorCheckStatus: {
                    data: action.data,
                    isLoading: false,
                    isLoaded: true,
                    error: null,
                },
            };
        }
        case BRAND__ERROR_CHECK__FAILURE: {
            return {
                ...state,
                errorCheckStatus: {
                    data: {},
                    isLoading: false,
                    isLoaded: false,
                    error: action.error,
                },
            };
        }
        default: {
            return state;
        }
    }
}
